import { render, staticRenderFns } from "./FieldRegions.vue?vue&type=template&id=2d1a9ab0&"
import script from "./FieldRegions.vue?vue&type=script&lang=js&"
export * from "./FieldRegions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports